export default "__VITE_ASSET__B7YPL5R4__"